export const CopyLinkIcon = () => (
  <svg
    tabIndex={-1}
    focusable="false"
    className="svg-icon icon-copylink"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2 7.3H9.1a1.8 1.8 0 00-1.8 1.8v8.1A1.8 1.8 0 009.1 19h8.1a1.8 1.8 0 001.8-1.8V9.1a1.8 1.8 0 00-1.8-1.8z"
      stroke="#27292D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.7 12.7h-.9A1.8 1.8 0 011 10.9V2.8A1.8 1.8 0 012.8 1h8.1a1.8 1.8 0 011.8 1.8v.9"
      stroke="#27292D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
